import React from 'react'
import { PurposeView } from 'pages/policyCenter/purposes/view/PurposeView'
import { PurposeViewProvider } from 'pages/policyCenter/purposes/view/context/PurposeViewContext'

export const PurposeViewContainer: React.FC = () => {
  return (
    <PurposeViewProvider>
      <PurposeView />
    </PurposeViewProvider>
  )
}
